import { TableEntry } from "../TableEntry";
import { removeMacros } from "../../util/spell";

export const Entry = ({ entry }) => {
    if (typeof entry === 'string') {
        return <p>{removeMacros(entry)}</p>;
    } else if (entry.hasOwnProperty('roll')) {
        return <p>{entry.roll.min} - {entry.roll.max}</p>
    } else {
        const { type, items = [], name, entries = [] } = entry;
        
        switch (type) {
            case 'list':
                const allStrings = !(items.some(i => typeof i !== 'string'));
                return ( allStrings ? <ul>
                    {items.map((item, i) => (
                        typeof item === 'string' ? 
                            (allStrings ? 
                                <li  key={i} className='listItem'>{removeMacros(item)}</li> 
                            : 
                                <p  key={i} className='listItem'>{removeMacros(item)}</p>
                            )
                        : 
                            <Entry key={i} entry={item} />
                        )
                    )}
                </ul> : <>
                    {items.map((item, i) => (
                        typeof item === 'string' ? 
                            <p  key={i} className='listItem'>{removeMacros(item)}</p> 
                        : 
                            <Entry key={i} entry={item} />
                        )
                    )}
                </>);
            case 'item':
            case 'entries':
                return (<>
                    <h4>{name}</h4>
                    {entries.map((e, i) => <Entry key={i} entry={e} />)}
                </>);
            case 'table':
                return <TableEntry entry={entry} />
            default:
                console.log(entry);
                return <div />;
        }
    }
}